import React from 'react';
import { Box } from '@mui/material';
import {
  DateRangeItem,
  DateRanges,
  useDateRangesInputContext,
} from './DateRangesInput.context';
import { StaticDatePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';

export type DateRangePickerPanelProps = {
  maxWidth?: number;
  maxHeight?: number;
};

export const DateRangePickerPanel = ({
  maxWidth = 320,
  maxHeight = 340,
}: DateRangePickerPanelProps) => {
  const {
    disabled,
    reply,
    dateRanges,
    activeDateRange = { mode: 'default', index: undefined },
    setDateRanges,
    setActiveDateRange,
    renderDay,
    value,
    handleChange,
  } = useDateRangesInputContext();

  const { id } = dateRanges[activeDateRange.mode]?.find(
    item => item.id === activeDateRange?.index
  ) || {
    start: null,
    end: null,
  };

  return (
    <Box
      sx={{
        border: `1px solid rgba(0, 0, 0, 0.12)`,
        borderRadius: 1,
        overflow: 'hidden',
        // maxWidth,
        maxHeight,
        ...((dateRanges?.default.length === 0 || !id) &&
        activeDateRange.mode === 'default'
          ? {
              pointerEvents: 'none',
              opacity: 0.4,
            }
          : {}),
      }}
    >
      <StaticDatePicker
        disabled={disabled && !reply}
        disablePast
        displayStaticWrapperAs="desktop"
        value={value} // used to move between months only
        onChange={handleChange}
        renderInput={params => <TextField {...params} />}
        renderDay={renderDay}
      />
    </Box>
  );
};
